import Vue from 'vue'
import Service from '../../services/Orcamento'
import {
    mapGetters,
    mapActions,
    mapMutations
} from './lib'
import Decimal from 'decimal.js'

const getDefaultState = () => {
    return {
        waitingSave: null,
        status: 0,
        error: {},
        obj: {
            published: false,
            allow_save: true
        },
        rows: [],
        mRows: [],
        rowsById: {},
        mRowsById: {},
        charges: [],
        delete: [],
        id: null,
        key: new Date().toUTCString(),
        totais: {
            t_km: 0.000000,
            m_km: 0.000000,
            m_ali: 0.000000,
            m_alo: 0.000000,
            preco_dia: 0.000000,
            preco_hora: 0.000000,
            custo_homem_dia: 0.000000,
            total_encargos: 0.000000,
            total_mo_ep: 0.000000,
            total_liq_eq: 0.000000,
            total_custos_liq: 0.000000,
            prc_enc_especiais: 0.000000,
            total_prc_c_e_m: 0.000000,
            m_trab_hora: 0.000000
        },
        pages: [],
        page: 0,
        exp_cp_id : 0
    }
}

const Orcamento = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        clear: (state) => {
            clearTimeout(state.waitingSave)
            Object.assign(state, {}, getDefaultState())
        },
        key: (state, value) => {
            state.key = value
        },
        set: (state, payload) => {
            state.obj = Object.assign({}, state.obj, payload)
            if(state.obj.cef4 == 0){
                state.obj.cef4 = state.obj.latest_cef4
            }
        },
        setRows: (state, payload) => {
            Vue._.forEach(payload, (v, i) => {
                if(!v.parent_line_id){
                    v.parent_line_id = v.id
                }
                v.short_description = v.description.substring(0, 97) + '...'
                v.old_product_id = v.product_id
                v.index = i
                state.rows.push(v)
                state.rowsById[v.id] = v
            })
        },
        setDelete: (state, payload) => {
            state.delete = payload
        },
        setSingleDelete: (state, payload) => {
            state.delete.push(payload)
        },
        setRow: (state, payload) => {
            for (const key in payload.row) {
                let value = payload.row[key];
                if (payload.row.hasOwnProperty(key)) {
                    state.rows[payload.index][key] = value
                }
            }
            state.rows[payload.index].short_description = payload.row.description.substring(0, 97) + '...'
            state.rows[payload.index].old_product_id = payload.row.product_id
            state.rows[payload.index].index = payload.index
            state.rowsById[state.rows[payload.index].id] = state.rows[payload.index]
        },
        setRowText: (state, payload) => {
            state.rows[payload.index][payload.key] = payload.value.substring(0, 4000)
            state.rows[index].short_description = state.rows[index].description.substring(0, 97) + '...'
        },
        setCharges: (state, payload) => {
            state.charges = payload
        },
        setCharge: (state, payload) => {
            for (const key in payload.charge) {
                let value = payload.charge[key];
                if (payload.charge.hasOwnProperty(key)) {
                    state.charges[payload.index][key] = value
                }
            }
        },
        parseObj: (state) => {
            state.obj.temp_created_by_user_id = state.obj.created_by_user_id
            for (var i = 1; i <= 17; i++) {
                state.obj['cef' + i] = Number(state.obj['cef' + i]).toFixed(2)
            }
        },
        parseRow: (state, index) => {
            state.rows[index].short_description = state.rows[index].description.substring(0, 97) + '...'
            state.rows[index].old_product_id = state.rows[index].product_id
            
            for (var i = 1; i <= 42; i++) {
                context.state.rows[index]['c' + i] = context.state.rows[index]['c' + i].replace(/,/gi,".")
            }

        },
        setupYield: (state, index) => {
            if ((state.rows[index].id != state.rows[index].parent_line_id) && (state.rows[index].line_type != 'A')) {
                state.rows[index].yield = Number(state.rowsById[state.rows[index].parent_line_id].c1)
            } else {
                state.rows[index].yield = Number(state.rows[index].c1)
            }
        },
        parseCharge: (state, index) => {
            state.charges[index].total_cost = Number(state.charges[index].total_cost).toFixed(2)
            state.charges[index].cost = Number(state.charges[index].cost).toFixed(2)
            state.charges[index].total_cost = Number(state.charges[index].total_cost).toFixed(2)
        },
        addRows: (state, payload) => {
            payload.short_description = payload.description.substring(0, 97) + '...'
            payload.old_product_id = payload.product_id
            payload.index = state.rows.length
            state.rows.push(payload)
            state.rowsById[payload.id] = payload
        },
        addCharges: (state, payload) => {
            state.charges.push(payload)
        },
        setId: (state, payload) => {
            state.id = payload
        },
        resetTotais: (state) => {
            for (const key in state.totais) {
                if (state.totais.hasOwnProperty(key)) {
                    state.totais[key] = 0
                }
            }
        },
        setupPages: (state) => {
            state.pages = []
            // let begin = true
            // let end = false
            state.pages.push({
                start: 0,
                end: state.rows.length
            })
            // Vue._.forEach(state.rows, function (v, i) {
            //     if (begin) {
            //         state.pages.push({
            //             start: i,
            //             end: i
            //         })
            //         begin = false
            //     }
            //     if (!begin && !end && ((i + 1) % 20 == 0)) {
            //         end = true
            //     }
            //     if (end && state.rows[i + 1] && state.rows[i + 1].id == state.rows[i + 1].parent_line_id) {
            //         end = false
            //         begin = true
            //     }
            //     state.pages[state.pages.length - 1].end = i
            // })
        },
        setError: (state, payload) => {
            state.status = -1
            setTimeout(function(){
                state.status = 0
            }, 5000)
        },
        resetError: (state) => {
            state.status = 0
            state.error = {}
        },
        setSuccess: (state, payload) => {
            if (state.status > 0) {
                state.status -= 1
            }
        },
        setLoading: (state, payload) => {
            state.status = (state.status < 0 ? 0 : state.status) + 1
        },
        error: (state, payload) => {
            state.error = payload;
        },
        page: (state, payload) => {
            state.page = payload.page - 1
        },
        expand: (state, payload) => {
            state.exp_cp_id = payload.id
        },
        ...mapMutations('obj', 'ObjProp'),
        ...mapMutations('totais', 'TotaisProp')
    },
    getters: {
        line_types: state => {
            return [{
                    id: 'P',
                    description: 'product'
                },
                {
                    id: 'L',
                    description: 'mao_obra'
                },
                {
                    id: 'E',
                    description: 'equipamento'
                },
                {
                    id: 'A',
                    description: 'acessorio'
                }
            ]
        },
        line_type: (state, getters) => (id) => {
            const types = getters.line_types
            return Vue._.find(types, ['id', id]);
        },
        recs: state => (id) => {
            return Vue._.filter(state.rows, (v, i, c) => {
                return v.id == v.parent_line_id || v.id == id
            })
        },
        key: state => {
            return state.key
        },
        obj: state => {
            return state.obj
        },
        rows: state => {
            return Vue._.filter(Vue._.slice(state.rows, (state.pages[state.page] ? state.pages[state.page].start : 0), (state.pages[state.page] ? state.pages[state.page].end + 1 : 0)), function(v){
                return v.id == v.parent_line_id || v.parent_line_id == state.exp_cp_id
            })
        },
        delete: state => {
            return state.delete
        },
        deleteAll: state => {
            return state.delete.length == state.rows.length && state.delete.length > 0
        },
        charges: state => {
            return state.charges
        },
        status: state => {
            return state.status
        },
        total_unit: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c36 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c37 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_acerto: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c22 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_coo: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c35 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_cc: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c33 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_ce: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c31 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_cm: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id ? v.c29 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_vt: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + (v.id == v.parent_line_id && v.line_type != 'L' && v.line_type != 'E' ? v.c39 : 0)
            }, 0)
            return v.toFixed(4)
        },
        total_value_eq: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + v.c10
            }, 0)
            return v.toFixed(4)
        },
        total_value_mo: state => {
            const v = Vue._.reduce(state.rows, function (a, v, i, c) {
                return a + v.c20
            }, 0)
            return v.toFixed(4)
        },
        real_percentage_cm: (state, getters) => {
            const v = (getters.total_value > 0 ? (getters.total_value_cm / getters.total_value) * 100 : 0)
            return v.toFixed(2)
        },
        real_percentage_ce: (state, getters) => {
            const v = (getters.total_value > 0 ? (getters.total_value_ce / getters.total_value) * 100 : 0)
            return v.toFixed(2)
        },
        pages: state => {
            return state.pages.length
        },
        page: state => {
            return state.page + 1
        },
        expanded: state => {
            return state.exp_cp_id
        },
        ...mapGetters('obj', 'ObjProp'),
        ...mapGetters('totais', 'TotaisProp', function (value) {
            return Number(value).toFixed(4)
        })
    },
    actions: {
        clear: (context) => {
            context.commit('clear')
        },
        init: (context, payload) => {
            context.commit('setLoading', {module: 'Store', function: 'init'})
            context.commit('setId', payload.id)
            return new Promise((resolve, reject) => {
                context.dispatch('refresh').then(() => {
                    context.dispatch('app/estimate_products', {
                        company: context.rootState.company,
                        estimate: context.state.obj.id
                    }, {
                        root: true
                    }).then(() => {
                        context.commit('setSuccess', {module: 'Store', function: 'init'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'init'})
                        context.commit('error', error)
                        reject(error)
                    })
                }).catch((error) => {
                    context.commit('setError', {module: 'Store', function: 'init'})
                    context.commit('error', error)
                    reject(error)
                })
            })
        },
        set: (context, value) => {
            context.commit('setLoading', {module: 'Store', function: 'set'})
            context.commit('set', value.payload)
            context.commit('parseObj')
            context.commit('setSuccess', {module: 'Store', function: 'set'})
        },
        setRows: (context, value) => {
            context.commit('setLoading', {module: 'Store', function: 'setRows'})
            context.commit('setRows', value.payload)
            Vue._.forEach(context.state.rows, (v, i) => {
                context.commit('parseRow', i)
            })
            context.commit('setSuccess', {module: 'Store', function: 'setRows'})
        },
        setDelete: (context, value) => {
            context.commit('setLoading', {module: 'Store', function: 'setDelete'})
            context.commit('setDelete', value.payload)
            context.commit('setSuccess', {module: 'Store', function: 'setDelete'})
        },
        deleteAll: (context, value) => {
            context.commit('setLoading', {module: 'Store', function: 'deleteAll'})
            context.commit('setDelete', [])
            if (value.payload == true) {
                Vue._.forEach(context.state.rows, (v) => {
                    context.commit('setSingleDelete', v.id)
                })
            }
            context.commit('setSuccess', {module: 'Store', function: 'deleteAll'})
        },
        setCharges: (context, value) => {
            context.commit('setLoading', {module: 'Store', function: 'setCharges'})
            context.commit('setCharges', value.payload)
            Vue._.forEach(context.state.charges, (v, i) => {
                context.commit('parseCharge', i)
            })
            context.commit('setSuccess', {module: 'Store', function: 'setCharges'})
        },
        refresh: (context) => {
            context.commit('setLoading', {module: 'Store', function: 'refresh'})
            let control = 0
            return new Promise((resolve, reject) => {
                Service.get(context.rootState.company, context.state.id).then((data) => {
                    context.dispatch('set', {
                        payload: data
                    })
                    control = control + 2
                    context.dispatch('refreshCharges').then(() => {
                        control = control - 1
                        if (control == 0) {
                            context.dispatch('calcular', {
                                field: '*',
                                index: -1
                            })
                            context.commit('setSuccess', {module: 'Store', function: 'refresh'})
                            resolve()
                        }
                    }).catch((error) => {
                        control = control - 1
                        context.commit('setError', {module: 'Store', function: 'refresh'})
                        context.commit('error', error)
                        reject(error)
                    })
                    context.dispatch('refreshLines').then(() => {
                        control = control - 1
                        if (control == 0) {
                            context.dispatch('calcular', {
                                field: '*',
                                index: -1
                            })
                            context.commit('setSuccess', {module: 'Store', function: 'refresh'})
                            resolve()
                        }
                    }).catch((error) => {
                        control = control - 1
                        context.commit('setError', {module: 'Store', function: 'refresh'})
                        context.commit('error', error)
                        reject(error)
                    })
                }).catch((error) => {
                    control = 0
                    context.commit('setError', {module: 'Store', function: 'refresh'})
                    context.commit('error', error)
                    reject(error)
                })
            })
        },
        refreshLines: (context) => {
            context.commit('setLoading', {module: 'Store', function: 'refreshLines'})
            return new Promise((resolve, reject) => {
                Service.lines.all(context.rootState.company, context.state.id).then((data) => {
                    context.state.rows.splice(0, context.state.rows.length)
                    context.commit('setRows', data)
                    context.dispatch('reorder').then(() => {
                        context.commit('setSuccess', {module: 'Store', function: 'refreshLines'})
                        context.dispatch('temporalSaveLines')
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'refreshLines'})
                        context.commit('error', error)
                        reject(error)
                    })
                }).catch((error) => {
                    context.commit('setError', {module: 'Store', function: 'refreshLines'})
                    context.commit('error', error)
                    reject(error)
                })
            })
        },
        refreshCharges: (context) => {
            context.commit('setLoading', {module: 'Store', function: 'refreshCharges'})
            return new Promise((resolve, reject) => {
                Service.charges.all(context.rootState.company, context.state.id).then((data) => {
                    context.commit('setCharges', data)
                    Vue._.forEach(context.state.charges, (v, i) => {
                        context.commit('parseCharge', i)
                    })
                    context.commit('setSuccess', {module: 'Store', function: 'refreshCharges'})
                    resolve()
                }).catch((error) => {
                    context.commit('setError', {module: 'Store', function: 'refreshCharges'})
                    context.commit('error', error)
                    reject(error)
                })
            })
        },
        setCurrencyRate: (context) => {
            if (!context.state.obj.published) {
                context.commit('setLoading', {module: 'Store', function: 'setCurrencyRate'})
                context.state.obj.cef4 = context.state.obj.latest_cef4
                Vue._.forEach(context.state.rows, function (v) {
                    v.c11 = context.state.obj.latest_cef4
                })
                context.dispatch('calcular', {
                    field: '*',
                    index: -1
                })
                context.dispatch('save')
                context.dispatch('saveLines')
                context.commit('setSuccess', {module: 'Store', function: 'setCurrencyRate'})
            }
        },
        setDefaultValue: (context, payload) => {
            if (!context.state.obj.published) {
                context.commit('setLoading', {module: 'Store', function: 'setDefaultValue'})
                Vue._.forEach(context.state.rows, function (v) {
                    v[payload.row_field] = context.state.obj[payload.field]
                })
                context.dispatch('calcular', {
                    field: '*',
                    index: -1
                })
                context.dispatch('save')
                context.dispatch('saveLines')
                context.commit('setSuccess', {module: 'Store', function: 'setDefaultValue'})
            }
        },
        newLine: (context) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'newLine'})
                var obj = {}
                obj.c5 = context.state.obj.cef1
                obj.c6 = context.state.obj.cef2
                obj.c8 = context.state.obj.cef3
                obj.c11 = context.state.obj.cef4
                obj.c12 = context.state.obj.cef5
                obj.c17 = context.state.obj.cef10
                obj.c3 = context.state.obj.cef13
                obj.c42 = context.state.obj.cef14
                obj.line = Number.parseInt(context.state.rows.length)
                return new Promise((resolve, reject) => {
                    Service.lines.add(context.rootState.company, context.state.obj.id, obj).then((data) => {
                        context.commit('addRows', data[0])
                        context.commit('parseRow', context.state.rows.length - 1)
                        context.commit('setupPages')
                        context.state.page = context.state.pages.length - 1
                        context.commit('setSuccess', {module: 'Store', function: 'newLine'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'newLine'})
                        context.commit('error', error)
                        reject(error)
                    });
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        newCharge: (context, payload) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'newCharge'})
                var obj = {}
                obj.estimate_charge_type_id = payload.estimate_charge_type_id
                obj.cost = 0.00
                return new Promise((resolve, reject) => {
                    Service.charges.add(context.rootState.company, context.state.obj.id, obj).then((data) => {
                        context.commit('addCharges', data)
                        context.commit('parseCharge', context.state.charges.length - 1)
                        context.commit('setSuccess', {module: 'Store', function: 'newCharge'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'newCharge'})
                        context.commit('error', error)
                        reject(error)
                    });
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        calcular: (context, payload) => {
            // const startTime = window.performance.now()
            if((payload.index != undefined) && (payload.field != undefined) && (payload.field != '*') && (payload.index > -1)){
                context.state.rows[payload.index][payload.field] = context.state.rows[payload.index][payload.field].replace(/,/gi,".")
            }
            var dArr = []
            Vue._.forEach(context.state.rows, function (v) {
                if (
                    v.id != v.parent_line_id &&
                    context.state.rowsById[v.parent_line_id].product_id != context.state.rowsById[v.parent_line_id].old_product_id
                ) {
                    dArr.push(v.id)
                }
            })
            context.commit('setDelete', dArr)
            context.dispatch('delLines')

            if (dArr.length == 0) {
                context.commit('setLoading', {module: 'Store', function: 'calcular'})
                try {
                    context.commit('resetTotais')
                    context.state.mRows.splice(0, context.state.mRows.length)
                    context.state.mRows = Vue._.cloneDeep(context.state.rows)
                    context.state.mRowsById = {}
                    Vue._.forEach(context.state.mRows, (v) => {
                        context.state.mRowsById[v.id] = v
                    })
                    ////////////////////////////////////////////////////////////////////////
                    // Quantidades Materiais e Exportação
                    ////////////////////////////////////////////////////////////////////////
                    var t_horas = 0
                    var t15 = 0
                    var t16 = 0
                    Vue._.forEach(context.state.mRows, function (v, i, c) {
                        if(v.line_type == 'L' || v.line_type == 'E'){
                            v.c2 = 0
                        }
                        if((v.id == v.parent_line_id) && (c[i + 1] != undefined) && v.id == c[i + 1].parent_line_id){
                            v.c17 = 0
                            v.composite_header = true
                        }else{
                            v.composite_header = false
                        }
                    
                        if ((v.id != v.parent_line_id) && (v.line_type != 'A')) {
                            v.yield = context.state.mRowsById[v.parent_line_id].c1
                        } else {
                            v.yield = v.c1
                        }
                        
                        v.c7 = v.c2 * (1 - (v.c5 / 100))
                        v.c7 = v.c7 * (1 - (v.c6 / 100))
                        if (v.id != v.parent_line_id && (v.line_type != 'A') && v.line_type != 'L' && v.line_type != 'E') {
                            v.c7 = (v.c7 * v.c1)
                        }
                        v.c7 = v.c7 + v.c4
                        v.c9 = v.c7 * v.c8
                        v.c10 = v.yield * v.c9
                        v.c13 = (v.c9 * v.c11) * v.c12
                        v.c14 = v.yield * v.c13

                        if (payload.field == 'c15' && (v.line_type == 'L' || (v.line_type == 'A') || v.line_type == 'E') && (v.parent_line_id == c[payload.index].id)) {
                            v.c15 = context.state.mRowsById[v.parent_line_id].c15
                        }
                        if (payload.field == 'c16' && (v.line_type == 'L' || (v.line_type == 'A') || v.line_type == 'E') && (v.parent_line_id == c[payload.index].id)) {
                            v.c16 = context.state.mRowsById[v.parent_line_id].c16
                        }
                    ////////////////////////////////////////////////////////////////////////
                    // Mão de Obra
                    ////////////////////////////////////////////////////////////////////////
                        const l_t_horas = (v.c15 * 8) + v.c16
                        ////
                        var c_l_tot = v.c15 + Math.ceil(v.c16 / 8)
                        if(context.state.obj.alojamento){
                            c_l_tot = Math.ceil(c_l_tot / 5)
                        }
                        if (v.id == v.parent_line_id){
                            context.state.totais.m_trab_hora += (l_t_horas)
                        }
                        ////
                        const p_t_horas = (context.state.mRowsById[v.parent_line_id].c15 * 8) + context.state.mRowsById[v.parent_line_id].c16
                        if (l_t_horas > p_t_horas) {
                            context.state.mRowsById[v.parent_line_id].c15 = v.c15
                            context.state.mRowsById[v.parent_line_id].c16 = v.c16
                        }
                        if (v.id == v.parent_line_id && v.line_type != 'L' && v.line_type != 'E') {
                            t_horas = t_horas + (v.c15 * 8) + v.c16
                        }
                        if (v.id != v.parent_line_id) {
                            v.department_id = context.state.mRowsById[v.parent_line_id].department_id
                        }
                    ////////////////////////////////////////////////////////////////////////
                        if (v.line_type != 'L' && v.line_type != 'E' && v.id == v.parent_line_id) {
                            t15 = t15 + v.c15
                            t16 = t16 + v.c16
                        }
                    })
                    context.state.obj.cef9 = (t15 + (t16 / 8))
                    ////////////////////////////////////////////////////////////////////////
                    const tMO = Vue._.reduce(context.state.mRows, (a, v, i, c) => {
                        if (v.c17 > 0) {
                            a.tl += 1
                            a.tMO += v.c17 * (v.c15 + (v.c16 / 8))
                        }
                        if(v.line_type == 'L'){
                            a.mc_mo += (v.c17 * v.c41)
                            a.tr_mo += v.c17
                        }
                        return a
                    }, {
                        tl: 0.00,
                        tMO: 0.00,
                        mc_mo: 0.00,
                        tr_mo: 0
                    })
                    context.state.obj.cef10 = Math.ceil(tMO.tMO / (context.state.obj.cef9 > 0 ? context.state.obj.cef9 : 1))
                    const d_mo = context.state.obj.cef12 - (tMO.tr_mo > 0 ? tMO.mc_mo / tMO.tr_mo : 0)

                    if (context.state.obj.alojamento) {
                        context.state.totais.t_km = (Math.ceil(context.state.obj.cef9 / 5) * Number(context.state.obj.cef6)) * 2
                    } else {
                        context.state.totais.t_km = (Math.ceil(context.state.obj.cef9) * Number(context.state.obj.cef6)) * 2
                    }
                    context.state.totais.m_km = context.state.totais.t_km * context.state.obj.cef11
                    
                    if (context.state.obj.alojamento) {
                        context.state.totais.m_alo = (Math.ceil(context.state.obj.cef9) - 1) * Number(context.state.obj.cef8) / Math.ceil(context.state.obj.cef9)
                    }
                    if (context.state.obj.alimentacao) {
                        context.state.totais.m_ali = (Math.ceil(context.state.obj.cef9) - 1) * Number(context.state.obj.cef7) / Math.ceil(context.state.obj.cef9)
                    }
                    ////////////////////////////////////////////////////////////////////////
                    Vue._.forEach(context.state.mRows, function (v) {
                        if(v.line_type == 'L' && payload.field == 'cef12'){
                            v.c41 += d_mo
                        }
                        if (context.state.obj.cef9 > 0 && v.c41 > 0) {
                            if (v.line_type == 'E') {
                                v.c40 = ((v.c17 * v.c41) * 8)
                            } else {
                                v.c40 = ((v.c17 * v.c41) * 8) + (v.c17 * context.state.totais.m_alo)  + (v.c17 * context.state.totais.m_ali)
                            }
                        } else {
                            v.c40 = 0
                        }
                        const diario_km = context.state.totais.m_km / (context.state.totais.m_trab_hora > 0 ? (context.state.totais.m_trab_hora / 8) : 1)
                        const preco_dia = v.c40 + ((diario_km / (context.state.obj.cef10 > 0 ? context.state.obj.cef10 : 1)) * v.c17)
                        const preco_hora = preco_dia / 8

                        v.c19 = ((v.c15 * preco_dia) + (v.c16 * preco_hora))

                        v.c18 = v.c19 / (v.yield > 0 ? v.yield : 1)

                        if (v.id != v.parent_line_id && (v.line_type == 'A')) {
                            const l_days = v.c15 + (v.c16 / 8)
                            v.c20 = v.c18 + (Math.ceil(l_days) * v.c13)
                        } else {
                            v.c20 = v.c18 + v.c13
                        }
                    })
                    ////////////////////////////////////////////////////////////////////////
                    context.state.totais.total_encargos = Vue._.reduce(context.state.charges, (a, v) => {
                        v.total_cost = Number(v.cost) * (v.daily_cost ? Math.ceil(context.state.obj.cef9) : 1)
                        return a + v.total_cost
                    }, 0.000000)

                    const tEnc = Vue._.reduce(context.state.mRows, (a, v) => {
                        a.total_mo_ep = a.total_mo_ep + v.c19

                        a.total_liq_eq = a.total_liq_eq + v.c14

                        return a
                    }, {total_mo_ep: 0.000000, total_liq_eq: 0.000000})
                    context.state.totais.total_mo_ep = tEnc.total_mo_ep
                    context.state.totais.total_liq_eq = tEnc.total_liq_eq
                    ////////////////////////////////////////////////////////////////////////
                    context.state.totais.total_custos_liq = context.state.totais.total_liq_eq + context.state.totais.total_mo_ep + context.state.totais.total_encargos
                    if (context.state.totais.total_custos_liq > 0) {
                        context.state.totais.prc_enc_especiais = (context.state.totais.total_encargos / context.state.totais.total_custos_liq) * 100
                    }
                    var t_labour_total = 0
                    Vue._.forEach(context.state.mRows, function (v) {
                        v.c23 = ((context.state.totais.prc_enc_especiais / 100) != 1 ? Math.ceil(((v.c20 / (1 - (context.state.totais.prc_enc_especiais / 100))) - v.c20) * 100) / 100 : 0)
                        v.c24 = v.c23 * v.yield
                    ////////////////////////////////////////////////////////////////////////
                        const s1 = v.c20 + v.c23
                        v.c26 = Math.ceil(((s1 / (1 - (v.c25 / 100))) - s1) * 100) / 100
                        v.c27 = v.c26 * v.yield
                        v.c38 = v.c20 + v.c23 + v.c26
                        v.c39 = v.c38 * v.yield
                    ////////////////////////////////////////////////////////////////////////
                        if (v.id == v.parent_line_id && (v.line_type == 'L' || v.line_type == 'E')) {
                            t_labour_total = t_labour_total + v.c19
                        }
                    })
                    ////////////////////////////////////////////////////////////////////////
                    Vue._.forEach(context.state.mRows, function (v) {
                        if (v.id != v.parent_line_id) {
                            const unit = (context.state.mRowsById[v.parent_line_id].yield > 0 ? (v.c39 / context.state.mRowsById[v.parent_line_id].yield) : 0)
                            const total = (context.state.mRowsById[v.parent_line_id].yield > 0 ? v.c39 : 0)

                            context.state.mRowsById[v.parent_line_id].c38 += unit
                            context.state.mRowsById[v.parent_line_id].c39 += total

                            context.state.mRowsById[v.parent_line_id].c17 += v.c17
                        }
                        if (v.id == v.parent_line_id && (v.line_type != 'L' && v.line_type != 'E')) {
                            const p_h = ((v.c15 * 8) + v.c16) / (t_horas > 0 ? t_horas : 1)
                            v.c38 += (p_h * t_labour_total) / (v.yield > 0 ? v.yield : 1)
                            v.c39 += (p_h * t_labour_total)
                        }
                    })
                    ////////////////////////////////////////////////////////////////////////
                    Vue._.forEach(context.state.mRows, function (v) {
                        
                        const p2 = new Decimal(v.c42).dividedBy(100)
                        const p3 = new Decimal(v.c3).dividedBy(100)
                        const p4 = new Decimal(context.state.obj.cef15).dividedBy(100)
                        const p5 = new Decimal(context.state.obj.cef16).dividedBy(100).plus(new Decimal(context.state.obj.cef17).dividedBy(100))

                        const s2 = (v.id == v.parent_line_id && (v.line_type != 'L' && v.line_type != 'E') ? new Decimal(v.c38) : new Decimal(0))
                        const m2 = p2.dividedBy(new Decimal(1).minus(p3).times(new Decimal(1).minus(p4).times((new Decimal(1).minus(p5)))))
                        
                        v.c28 = Math.ceil(((s2 / (1 - m2)) - s2) * 100) / 100
                        v.c29 = v.c28 * v.yield

                        const s3 = s2.plus(new Decimal(v.c28))
                        const m3 = p3.dividedBy(new Decimal(1).minus(p4).times(new Decimal(1).minus(p5)))

                        v.c30 = Math.ceil(((s3 / (1 - m3)) - s3) * 100) / 100
                        v.c31 = v.c30 * v.yield

                        const s4 = s3.plus(new Decimal(v.c30))
                        const m4 = p4.dividedBy(new Decimal(1).minus(p5))

                        v.c32 = Math.ceil(((s4 / (1 - m4)) - s4) * 100) / 100
                        v.c33 = v.c32 * v.yield

                        const s5 = s4.plus(new Decimal(v.c32))
                        const m5 = new Decimal(1).minus(p5)

                        v.c34 = Math.ceil(((s5 / m5) - s5) * 100) / 100
                        v.c35 = v.c34 * v.yield

                    })
                    ////////////////////////////////////////////////////////////////////////
                    Vue._.forEach(context.state.mRows, function (v, i) {
                        v.c22 = v.c21 * v.yield
                        v.c36 = (((v.id == v.parent_line_id && v.line_type != 'L' && v.line_type != 'E' ? v.c38 : 0) + v.c28 + v.c30 + v.c32 + v.c34 + v.c21) * 100) / 100
                        v.c37 = Vue._.round(v.c36, 4) * v.yield
                        context.state.rows[i].composite_header = v.composite_header
                        context.state.rows[i].yield = v.yield
                        context.state.rows[i].department_id = v.department_id

                        for (var iF = 1; iF <= 42; iF++) {
                            context.state.rows[i]['c' + iF] = v['c' + iF]
                        }
                    })
                    ////////////////////////////////////////////////////////////////////////
                    const fMO = Vue._.reduce(context.state.mRows, (a, v, i, c) => {
                        if(v.line_type == 'L'){
                            a.mc_mo += (v.c17 * v.c41)
                            a.tr_mo += v.c17
                        }
                        return a
                    }, {
                        mc_mo: 0.00,
                        tr_mo: 0
                    })
                    context.state.obj.cef12 = (fMO.tr_mo > 0 ? fMO.mc_mo / fMO.tr_mo : 0)
                    ////////////////////////////////////////////////////////////////////////
                    context.commit('setSuccess', {module: 'Store', function: 'calcular'})
                } catch (error) {
                    context.commit('error', error)
                    context.commit('setError', {module: 'Store', function: 'calcular'})
                }
            }
        },
        save: (context) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                return new Promise((resolve, reject) => {
                    Service.edit(context.rootState.company, context.state.obj.id, context.state.obj).then((data) => {
                        context.state.obj.allow_save = data.allow_save
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'save'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        publish: (context) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'publish'})
                return new Promise((resolve, reject) => {
                    Service.publish(context.rootState.company, context.state.obj.id).then((data) => {
                        context.dispatch('set', {
                            payload: data
                        })
                        context.commit('setSuccess', {module: 'Store', function: 'publish'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'publish'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        review: (context) => {
            if (context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'review'})
                return new Promise((resolve, reject) => {
                    Service.review(context.rootState.company, context.state.obj.id).then((data) => {
                        context.commit('clear')
                        context.dispatch('init', data).then(() => {
                            context.commit('setSuccess', {module: 'Store', function: 'review'})
                            resolve(data)
                        }).catch((error) => {
                            context.commit('setError', {module: 'Store', function: 'review'})
                            context.commit('error', error)
                            reject(error)
                        })
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'review'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        saveLine: (context, payload) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'saveLine'})
                const mIndex = context.state.pages[context.state.page].start + payload.index
                return new Promise((resolve, reject) => {
                    Service.lines.edit(context.rootState.company, context.state.obj.id, context.state.rows[mIndex].id, context.state.rows[mIndex]).then((data) => {
                        Vue._.forEach(data, function (v, i, c) {
                            if (context.state.rows[mIndex].id == v.id) {
                                context.commit('setRow', {
                                    index: mIndex,
                                    row: v
                                })
                            } else {
                                context.commit('addRows', v)
                            }
                        })
                        context.dispatch('reorder')
                        context.dispatch('calcular', {
                            field: '*',
                            index: -1
                        })
                        context.commit('setSuccess', {module: 'Store', function: 'saveLine'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'saveLine'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        saveAll: (context) => {
            context.state.obj.created_by_user_id = context.state.obj.temp_created_by_user_id
            context.commit('setLoading', {module: 'Store', function: 'saveAll'})
            context.dispatch('save').then(() => {
                context.commit('setSuccess', {module: 'Store', function: 'saveAll'})
            }).catch((error) => {
                context.commit('setError', {module: 'Store', function: 'saveAll'})
                context.commit('error', error)
            })
            context.dispatch('saveLines').then(() => {
                context.commit('setSuccess', {module: 'Store', function: 'saveAll'})
            }).catch((error) => {
                context.commit('setError', {module: 'Store', function: 'saveAll'})
                context.commit('error', error)
            })
        },
        saveLines: (context) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                return new Promise((resolve, reject) => {
                    Service.lines.editAll(context.rootState.company, context.state.obj.id, context.state.rows).then((data) => {
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'saveLines'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        temporalSaveLines: (context) => {
            context.state.waitingSave = setTimeout(function () {
                let run = 0;
                context.dispatch('save').then(() => {
                    run += 1
                    if (run === 2) {
                        context.dispatch('temporalSaveLines')
                    }
                }).catch((error) => {
                    context.commit('setError', {module: 'Store', function: 'temporalSaveLines'})
                    context.commit('error', error)
                    run += 1
                    if (run === 2) {
                        context.dispatch('temporalSaveLines')
                    }
                })
                context.dispatch('saveLines').then(() => {
                    run += 1
                    if (run === 2) {
                        context.dispatch('temporalSaveLines')
                    }
                }).catch((error) => {
                    context.commit('setError', {module: 'Store', function: 'temporalSaveLines'})
                    context.commit('error', error)
                    run += 1
                    if (run === 2) {
                        context.dispatch('temporalSaveLines')
                    }
                })
            }, 300000)

        },
        saveCharge: (context, payload) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'saveCharge'})
                return new Promise((resolve, reject) => {
                    Service.charges.edit(context.rootState.company, context.state.obj.id, context.state.charges[payload.index].id, context.state.charges[payload.index]).then((data) => {
                        context.commit('setCharge', {
                            index: payload.index,
                            row: data
                        })
                        context.commit('parseCharge', payload.index)
                        context.commit('setSuccess', {module: 'Store', function: 'saveCharge'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'saveCharge'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        delLine: (context, payload) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'delLine'})
                return new Promise((resolve, reject) => {
                    Service.lines.delete(context.rootState.company, context.state.obj.id, context.state.rows[payload.index].id).then((data) => {
                        context.state.rows.splice(payload.index, 1)
                        context.commit('setSuccess', {module: 'Store', function: 'delLine'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'delLine'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        delLines: (context) => {
            if (!context.state.obj.published && context.state.delete.length > 0 && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'delLines'})
                return new Promise((resolve, reject) => {
                    Service.lines.deleteAll(context.rootState.company, context.state.obj.id, context.state.delete).then((data) => {
                        context.state.delete = []
                        Vue._.forEach(data, (v) => {
                            const index = Vue._.findIndex(context.state.rows, ['id', v])
                            if (index > -1) {
                                context.state.rows.splice(index, 1)
                            }
                            let pIndex = Vue._.findIndex(context.state.rows, ['parent_line_id', v])
                            while(pIndex > -1){
                                context.state.rows.splice(pIndex, 1)
                                pIndex = Vue._.findIndex(context.state.rows, ['parent_line_id', v])
                            }
                        })
                        context.dispatch('calcular', {
                            field: '*',
                            index: -1
                        })
                        context.commit('setSuccess', {module: 'Store', function: 'delLines'})
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'delLines'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        delCharge: (context, payload) => {
            if (!context.state.obj.published && context.state.obj.allow_save) {
                context.commit('setLoading', {module: 'Store', function: 'delCharge'})
                return new Promise((resolve, reject) => {
                    Service.charges.delete(context.rootState.company, context.state.obj.id, context.state.charges[payload.index].id).then((data) => {
                        context.state.charges.splice(payload.index, 1)
                        context.commit('setSuccess', {module: 'Store', function: 'delCharge'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'delCharge'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        cmpCalcular: (context, payload) => {
            if (!context.state.obj.published) {
                context.commit('setLoading', {module: 'Store', function: 'cmpCalcular'})
                return new Promise((resolve, reject) => {
                    Service.composto.calcular(context.rootState.company, context.state.rows[payload.index].product_id, context.state.rows[payload.index].c1).then((data) => {
                        context.state.rows[payload.index].c2 = data.unit_prd
                        context.state.rows[payload.index].c4 = data.unit_acs
                        context.state.rows[payload.index].c15 = data.days
                        context.state.rows[payload.index].c16 = data.hours
                        context.state.rows[payload.index].c17 = data.lbr_n_rh
                        context.state.rows[payload.index].c41 = data.unit_lbr * Number(context.state.obj.cef4)
                        context.dispatch('calcular', payload)
                        context.commit('setSuccess', {module: 'Store', function: 'cmpCalcular'})
                        resolve()
                    }).catch((error) => {
                        context.commit('setError', {module: 'Store', function: 'cmpCalcular'})
                        context.commit('error', error)
                        reject(error)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    resolve()
                }, (error) => {
                    reject(error)
                })
            }
        },
        reorder: (context, payload) => {
            return new Promise((resolve, reject) => {
                if (payload && payload.newIndex != undefined && payload.oldIndex != undefined) {
                    if (!(typeof Number(payload.newIndex) === 'number' && (Number(payload.newIndex) % 1) === 0)) {
                        payload.newIndex = payload.oldIndex + 1
                    }
                    if (payload.newIndex < 1) {
                        payload.newIndex = 1
                    }
                    if (payload.newIndex > context.state.rows.length) {
                        payload.newIndex = context.state.rows.length
                    }
                    const rems = context.state.rows.splice(payload.oldIndex, 1)
                    context.state.rows.splice(Number.parseInt(payload.newIndex) - 1, 0, ...rems)
                }
                Vue._.forEach(context.state.rows, function (v, i) {
                    v.key = new Date().toUTCString()
                    v.line = i
                })
                Vue._.forEach(context.state.rows, function (v, i) {
                    if(context.state.rowsById[v.parent_line_id] === undefined){
                        v.parent_line_id = v.id
                    }
                    const obj = context.state.rowsById[v.parent_line_id]
                    v.cmp_order = (v.id == v.parent_line_id ? 0 : i + 1)
                    v.parent_line_order = obj.line
                })

                context.state.rows = Vue._.orderBy(context.state.rows, ['parent_line_order', 'cmp_order'], ['asc', 'asc'])
                Vue._.forEach(context.state.rows, function (v, i) {
                    v.line = i
                })
                context.commit('setupPages')
                if (payload && payload.id != undefined) {
                    const index = Vue._.findIndex(context.state.rows, ['id', payload.id])
                    context.state.page = Vue._.findIndex(context.state.pages, (page)=>{
                        return page.start <= index && index <= page.end
                    })
                    resolve(index)
                } else {
                    resolve(-1)
                }
            }, (error) => {
                context.commit('setError')
                context.commit('error', error)
                reject(error)
            })
        },
        ...mapActions('ObjProp', 'ObjProp', function(payload){
            if(payload.prop.includes('cef')){
                payload.value = payload.value.replace(/,/gi,".")
            }
        }),
        ...mapActions('TotaisProp', 'TotaisProp', function (payload) {
            payload.value = Number(payload.value)
        })
    }
}

export default Orcamento



// WEBPACK FOOTER //
// ./resources/js/modules/orcamento/Store.js